import { CarrierSetting } from '@rygen/rygen-ui/model';

import { BaseHttpController } from './BaseHttpController';

const endpoint = 'broker';

export class BrokerController extends BaseHttpController {
  constructor() {
    super(endpoint);
  }

  async findBrokerSettingsForScac(scac: string): Promise<CarrierSetting> {
    const response = await this.http.get<CarrierSetting>(
      `${scac}/client-config`,
    );
    return new CarrierSetting(response.data);
  }
}
